export default {"src":"/_next/static/media/arrow-up-left.76247ad4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};